import { ICONS } from "@utils/icons";

/**
 * Un lien est actif si son chemin correspond à l'URL courante. `/about` est
 * également actif sur la racine, puisque la route index rend la page « à propos ».
 *
 * @param {{path: string}} link - Entrée de NAV_LINKS
 * @param {string} pathname - Chemin courant
 * @returns {boolean}
 */
export const isNavLinkActive = (link, pathname) => {
  const current = pathname.toLowerCase();
  return (
    link.path.toLowerCase() === current ||
    (link.path === "/about" && current === "/")
  );
};

export const NAV_LINKS = [
  {
    path: "/about",
    labelKey: "about",
    icon: ICONS.navAbout,
  },
  {
    path: "/resume",
    labelKey: "resume",
    icon: ICONS.navResume,
  },
  {
    path: "/certificats",
    labelKey: "certificates",
    icon: ICONS.award,
  },
  {
    path: "/portfolio",
    labelKey: "portfolio",
    icon: ICONS.navPortfolio,
  },
];
